import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceUnderscore',
    standalone: false
})
export class ReplaceUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
